import { Fragment, memo } from 'react'
import PropTypes from 'prop-types'
import dayjs from 'dayjs'

import { formatters } from 'reactUtils/formatters'

import { Skeleton } from 'lmcv/components/Skeleton'
import { pluralize } from 'lmcv/modules/utils'

import { ToolTipInfo } from './ToolTipInfo'
import * as S from './styled'

function Points ({ user, isLoading }) {
  return (
    <div>
      <S.Header>
        <S.TextBalance>Seu saldo total é de:</S.TextBalance>

        <S.TicketBox>
          <S.Ticket>
            <S.TicketValue>
              {isLoading
                ? (
                    '0 pt'
                  )
                : (
                <Fragment>
                  {formatters.toDecimal(user.points.actual)}{' '}
                  {pluralize('pt', user.points.actual > 1)}
                </Fragment>
                  )}
            </S.TicketValue>
          </S.Ticket>
          <ToolTipInfo />
        </S.TicketBox>
      </S.Header>

      <S.TextExpiration>
        {isLoading
          ? (
          <Skeleton width="135px" height="13px" as="span" />
            )
          : (
          <Fragment>
            {formatters.toDecimal(user.points.toExpire)}{' '}
            {user.points.toExpire === 1 ? 'expira' : 'expiram'} dia{' '}
            {dayjs(user.points.expireAt).format('DD/MM/YYYY')}
          </Fragment>
            )}
      </S.TextExpiration>
    </div>
  )
}

Points.propTypes = {
  user: PropTypes.object,
  isLoading: PropTypes.bool.isRequired
}

export default memo(Points)
